import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {resetBgRemoverUpsellPanel} from '@Panels/bg-remover-upsell-panel/bg-remover-upsell-panel-reducer';
import {BG_REMOVER_UPSELL_PANEL_ID} from '@Panels/bg-remover-upsell-panel/bg-remover-upsell-panel.types';
import type {BgRemoverUpsellVariant} from '@Libraries/bg-remover-upsell-experiment.library';
import type {PremiumOnlyFeatureDialogOptions} from '@Libraries/upsell-dialog.library';

export const openBgRemoverUpsellModal = (variant: BgRemoverUpsellVariant, {onDialogLoaded, entryPoint}: PremiumOnlyFeatureDialogOptions): void => {
  // Clearing here keeps trial eligibility fresh per open; the panel refetches off empty state.
  window.PMW.redux.store.dispatch(resetBgRemoverUpsellPanel());
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.BG_REMOVER_UPSELL_MODAL,
      panelProps: {
        panelId: BG_REMOVER_UPSELL_PANEL_ID,
        variant,
        entryPoint,
      },
    })
  );

  if (typeof onDialogLoaded === 'function') {
    onDialogLoaded();
  }
};
